// Newcop Dubai Theme JavaScript
console.log("Theme JavaScript loaded!");

document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM Content Loaded - initializing components...");

  // Initialize all components
  // initProductNavigation();
  // initMobileMenu();
  // initSearchModal(); // Search functionality handled by search-modal.liquid snippet
  initCartDrawer();
  // initDropdowns();
  // initSmoothScrolling();
  // initLazyLoading();
  // initBrandMarquee(); // Initialize brand marquee animation

  // Initialize wishlist UI on page load
  const wishlistButtons = document.querySelectorAll("[data-product-id]");
  wishlistButtons.forEach((btn) => {
    const productId = btn.dataset.productId;
    updateWishlistUI(productId);
  });

  console.log("All components initialized!");
});

// Product Navigation
function initProductNavigation() {
  const navArrows = document.querySelectorAll(".nav-arrow");

  navArrows.forEach((arrow) => {
    arrow.addEventListener("click", function () {
      const sectionId = this.dataset.section;
      const productRow = document.getElementById(`product-row-${sectionId}`);
      const isNext = this.classList.contains("nav-next");

      if (productRow) {
        const scrollAmount = 300; // Adjust scroll amount
        const currentScroll = productRow.scrollLeft;
        const newScroll = isNext
          ? currentScroll + scrollAmount
          : currentScroll - scrollAmount;

        productRow.scrollTo({
          left: newScroll,
          behavior: "smooth"
        });
      }
    });
  });
}

// Search Modal - DISABLED (using header search panel instead)
/*
function initSearchModal() {
  // Use data-* API and class names expected by the snippet-based modal
  const searchToggle = document.querySelector("[data-search-toggle]");
  const searchModal = document.querySelector("[data-search-modal]");
  const searchCloses = document.querySelectorAll("[data-search-close]");

  if (searchToggle && searchModal) {
    searchToggle.addEventListener("click", function () {
      searchModal.classList.add("is-active");
      document.body.style.overflow = "hidden";
    });
  }

  if (searchCloses.length && searchModal) {
    searchCloses.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        searchModal.classList.remove("is-active");
        document.body.style.overflow = "";
      });
    });
  }
}
*/

// Cart Drawer
function initCartDrawer() {
  // Global cart drawer functions
  window.openCartDrawer = function () {
    const cartDrawer = document.getElementById("cart-drawer");
    if (cartDrawer) {
      cartDrawer.classList.add("is-open");
      document.body.style.overflow = "hidden";
      // Load fresh cart data when opening
      window.loadCartData();
      // Load recently viewed products
      if (typeof window.loadRecentlyViewed === 'function') {
        window.loadRecentlyViewed();
      }
    }
  };

  window.closeCartDrawer = function () {
    const cartDrawer = document.getElementById("cart-drawer");
    if (cartDrawer) {
      cartDrawer.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  };

  window.toggleCartDrawer = function () {
    const cartDrawer = document.getElementById("cart-drawer");
    if (cartDrawer) {
      if (cartDrawer.classList.contains("is-open")) {
        window.closeCartDrawer();
      } else {
        window.openCartDrawer();
      }
    }
  };

  // Add event listeners for close buttons
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-drawer-close]")) {
      e.preventDefault();
      window.closeCartDrawer();
    }
  });

  // Add event listeners for cart item controls
  document.addEventListener("click", function (e) {
    // Quantity controls
    if (e.target.closest("[data-quantity-minus]")) {
      e.preventDefault();
      const item = e.target.closest("[data-cart-item]");
      const itemKey = item.dataset.itemKey;
      const quantityInput = item.querySelector("[data-quantity-input]");
      const currentQuantity = parseInt(quantityInput.value);
      if (currentQuantity > 1) {
        updateCartItem(itemKey, currentQuantity - 1);
      }
    }

    if (e.target.closest("[data-quantity-plus]")) {
      e.preventDefault();
      const item = e.target.closest("[data-cart-item]");
      const itemKey = item.dataset.itemKey;
      const quantityInput = item.querySelector("[data-quantity-input]");
      const currentQuantity = parseInt(quantityInput.value);
      updateCartItem(itemKey, currentQuantity + 1);
    }

    // Remove item
    if (e.target.closest("[data-remove-item]")) {
      e.preventDefault();
      const item = e.target.closest("[data-cart-item]");
      const itemKey = item.dataset.itemKey;
      removeCartItem(itemKey);
    }
  });

  // Handle quantity input changes
  document.addEventListener("change", function (e) {
    if (e.target.closest("[data-quantity-input]")) {
      const item = e.target.closest("[data-cart-item]");
      const itemKey = item.dataset.itemKey;
      const newQuantity = parseInt(e.target.value);
      if (newQuantity > 0) {
        updateCartItem(itemKey, newQuantity);
      }
    }
  });

  // Add cart button event listeners
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-toggle]")) {
      e.preventDefault();
      console.log("Cart button clicked from theme.js");
      window.openCartDrawer();
    }
  });

  // Test cart drawer element on load
  const cartDrawer = document.getElementById("cart-drawer");
  console.log("Cart drawer element found on load:", cartDrawer);
  if (cartDrawer) {
    console.log("Cart drawer classes:", cartDrawer.className);
  }

  // Load cart data when drawer opens
  window.loadCartData = function () {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        console.log("Cart data loaded:", cart);
        updateCartDisplay(cart);
      })
      .catch((error) => {
        console.error("Error loading cart data:", error);
      });
  };

  // Update cart display with real data
  function updateCartDisplay(cart) {
    const cartItems = document.querySelector("[data-cart-items]");
    const cartCount = document.querySelectorAll("[data-cart-count]");
    const cartSubtotal = document.querySelector("[data-cart-subtotal]");
    const cartTotal = document.querySelector("[data-cart-total]");
    const cartSummary = document.querySelector("[data-cart-summary]");
    const cartActions = document.querySelector("[data-cart-actions]");
    const cartRecommended = document.querySelector("[data-cart-recommended]");

    // Helper function to escape HTML to prevent XSS
    function escapeHTML(str) {
      if (typeof str !== 'string') return '';
      return str.replace(/[&<>'"]/g, tag => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
      }[tag] || tag));
    }

    // Update cart count
    cartCount.forEach((element) => {
      element.textContent = cart.item_count;
    });

    if (cart.items.length === 0) {
      // Show empty cart
      if (cartItems) {
        cartItems.innerHTML = `
          <div class="cart-drawer__empty">
            <p>${window.CartTranslations && window.CartTranslations.empty ? window.CartTranslations.empty : 'Your cart is empty'}</p>
            <a href="/collections/all" class="cart-drawer__continue-shopping">${window.CartTranslations && window.CartTranslations.continue_shopping ? window.CartTranslations.continue_shopping : 'Continue shopping'}</a>
          </div>
        `;
      }
      if (cartSummary) cartSummary.style.display = "none";
      if (cartActions) cartActions.style.display = "none";
      if (cartRecommended) cartRecommended.style.display = "none";
      // Also hide recently viewed when cart is empty
      const cartRecentlyViewed = document.querySelector("[data-cart-recently-viewed]");
      if (cartRecentlyViewed) cartRecentlyViewed.style.display = "none";
    } else {
      // Show cart items
      if (cartItems) {
        cartItems.innerHTML = cart.items
          .map(
            (item) => `
          <div class="cart-drawer__item" data-cart-item data-item-key="${
            item.key
          }">
            <div class="cart-drawer__item-image">
              <img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" loading="lazy">
            </div>
            <div class="cart-drawer__item-content">
              <h4 class="cart-drawer__item-title">${escapeHTML(item.product_title)}</h4>
              ${
                item.variant_title
                  ? `<div class="cart-drawer__item-variant">${escapeHTML(item.variant_title)}</div>`
                  : ""
              }
              <div class="cart-drawer__item-price">${formatMoney(
                item.price
              )}</div>
              <div class="cart-drawer__item-quantity">
                <button class="cart-drawer__quantity-btn" data-quantity-minus>&#8722;</button>
                <input type="number" class="cart-drawer__quantity-input" data-quantity-input value="${
                  item.quantity
                }" min="1" readonly>
                <button class="cart-drawer__quantity-btn" data-quantity-plus>&#43;</button>
              </div>
              <div class="cart-drawer__item-actions">
                <button class="cart-drawer__remove-btn" data-remove-item>${window.CartTranslations && window.CartTranslations.remove ? window.CartTranslations.remove : 'Remove'}</button>
              </div>
            </div>
          </div>
        `
          )
          .join("");
      }

      // Update totals
      if (cartSubtotal)
        cartSubtotal.textContent = formatMoney(cart.total_price);
      if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
      if (cartSummary) cartSummary.style.display = "block";
      if (cartActions) cartActions.style.display = "flex";
      if (cartRecommended) cartRecommended.style.display = "none"; // replaced by recently-viewed
      // Trigger recently viewed loading
      if (typeof window.loadRecentlyViewed === 'function') {
        window.loadRecentlyViewed();
      }
    }
  }

  // Format money helper
  function formatMoney(cents) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR"
    }).format(cents / 100);
  }

  // Update cart item quantity
  function updateCartItem(itemKey, quantity) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: {
          [itemKey]: quantity
        }
      })
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log("Cart updated:", cart);
        updateCartDisplay(cart);
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      });
  }

  // Remove cart item
  function removeCartItem(itemKey) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: {
          [itemKey]: 0
        }
      })
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log("Item removed from cart:", cart);
        updateCartDisplay(cart);
      })
      .catch((error) => {
        console.error("Error removing item from cart:", error);
      });
  }

  // Load cart data on page load
  window.loadCartData();
}

// Dropdowns
function initDropdowns() {
  // Handle regular dropdowns
  const dropdowns = document.querySelectorAll(".dropdown");

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector(".dropdown-trigger");
    const content = dropdown.querySelector(".dropdown-content");

    // ... existing dropdown code ...
  });

  // Handle mega menu dropdowns - simple and reliable
  console.log("=== INITIALIZING MEGA MENU DROPDOWNS ===");

  const navItems = document.querySelectorAll(".header__nav-item--has-dropdown");
  const megaDropdowns = Array.from(
    document.querySelectorAll(".header__dropdown")
  );
  const dropdownsContainer = document.querySelector(".header__dropdowns");

  console.log("Found nav items:", navItems.length);
  console.log("Found dropdowns:", megaDropdowns.length);
  console.log("Found dropdowns container:", dropdownsContainer);

  // Debug: Log all nav items
  navItems.forEach((item, index) => {
    console.log(`Nav item ${index}:`, {
      element: item,
      category: item.getAttribute("data-category"),
      text: item.textContent.trim(),
      classes: item.className
    });
  });

  // Debug: Log all dropdowns
  megaDropdowns.forEach((dropdown, index) => {
    console.log(`Dropdown ${index}:`, {
      element: dropdown,
      dropdown: dropdown.getAttribute("data-dropdown"),
      classes: dropdown.className
    });
  });

  if (navItems.length === 0) {
    console.error(
      "No navigation items found with class: header__nav-item--has-dropdown"
    );
    return;
  }

  if (megaDropdowns.length === 0) {
    console.error("No dropdowns found with class: header__dropdown");
    return;
  }

  navItems.forEach((item, index) => {
    const category = item.getAttribute("data-category");
    console.log(`Setting up nav item ${index}:`, item, "Category:", category);

    // Find the corresponding dropdown
    const dropdown = document.querySelector(`[data-dropdown="${category}"]`);
    console.log(`Dropdown for ${category}:`, dropdown);

    if (dropdown) {
      // Show dropdown on hover
      item.addEventListener("mouseenter", () => {
        console.log("Mouse enter nav item:", category);

        // Hide all other dropdowns first
        megaDropdowns.forEach((d) => {
          d.classList.remove("header__dropdown--visible");
        });

        // Show current dropdown
        dropdown.classList.add("header__dropdown--visible");
        console.log("Added visible class to dropdown:", category);

        // Show the dropdowns container
        if (dropdownsContainer) {
          dropdownsContainer.classList.add("header__dropdowns--visible");
        }

        // Debug: Check if class was added
        console.log(
          "Dropdown classes after adding visible:",
          dropdown.className
        );
        console.log("Dropdown computed styles:", {
          opacity: window.getComputedStyle(dropdown).opacity,
          visibility: window.getComputedStyle(dropdown).visibility,
          pointerEvents: window.getComputedStyle(dropdown).pointerEvents
        });
      });

      // Hide dropdown when leaving nav item
      item.addEventListener("mouseleave", () => {
        console.log("Mouse leave nav item:", category);

        // Set a timeout to hide the dropdown
        setTimeout(() => {
          if (!dropdown.matches(":hover")) {
            dropdown.classList.remove("header__dropdown--visible");
            console.log("Removed visible class from dropdown:", category);

            // Hide container if no dropdowns are visible
            if (
              dropdownsContainer &&
              !megaDropdowns.some((d) =>
                d.classList.contains("header__dropdown--visible")
              )
            ) {
              dropdownsContainer.classList.remove("header__dropdowns--visible");
            }
          }
        }, 100);
      });

      // Keep dropdown visible when hovering over it
      dropdown.addEventListener("mouseenter", () => {
        console.log("Mouse enter dropdown:", category);
        dropdown.classList.add("header__dropdown--visible");

        // Ensure container is visible
        if (dropdownsContainer) {
          dropdownsContainer.classList.add("header__dropdowns--visible");
        }
      });

      // Hide dropdown when leaving it
      dropdown.addEventListener("mouseleave", () => {
        console.log("Mouse leave dropdown:", category);
        dropdown.classList.remove("header__dropdown--visible");

        // Hide container if no dropdowns are visible
        if (
          dropdownsContainer &&
          !megaDropdowns.some((d) =>
            d.classList.contains("header__dropdown--visible")
          )
        ) {
          dropdownsContainer.classList.remove("header__dropdowns--visible");
        }
      });
    } else {
      console.error(`No dropdown found for category: ${category}`);
    }
  });

  console.log("=== MEGA MENU DROPDOWNS INITIALIZATION COMPLETE ===");

  // Test: Try to manually show the first dropdown to see if CSS is working
  if (megaDropdowns.length > 0) {
    console.log("=== TESTING DROPDOWN VISIBILITY ===");
    const testDropdown = megaDropdowns[0];
    console.log("Test dropdown:", testDropdown);
    console.log(
      "Test dropdown data-dropdown:",
      testDropdown.getAttribute("data-dropdown")
    );

    // Try to show it manually
    // testDropdown.classList.add("header__dropdown--visible");
    // console.log("Added visible class to test dropdown");
    // console.log("Test dropdown classes:", testDropdown.className);

    // Also show the container
    // if (dropdownsContainer) {
    //   dropdownsContainer.classList.add("header__dropdowns--visible");
    //   console.log("Added visible class to dropdowns container");
    // }

    // Check computed styles
    const computedStyles = window.getComputedStyle(testDropdown);
    console.log("Test dropdown computed styles:", {
      opacity: computedStyles.opacity,
      visibility: computedStyles.visibility,
      pointerEvents: computedStyles.pointerEvents,
      display: computedStyles.display,
      position: computedStyles.position,
      zIndex: computedStyles.zIndex
    });

    // Remove the test class after 3 seconds
    setTimeout(() => {
      testDropdown.classList.remove("header__dropdown--visible");
      console.log("Removed test visible class");

      // Also hide the container
      if (dropdownsContainer) {
        dropdownsContainer.classList.remove("header__dropdowns--visible");
        console.log("Removed visible class from dropdowns container");
      }
    }, 3000);
  }
}

// Smooth Scrolling
function initSmoothScrolling() {
  const smoothScrollLinks = document.querySelectorAll('a[href^="#"]');

  smoothScrollLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const href = this.getAttribute("href");

      if (href !== "#") {
        e.preventDefault();
        const target = document.querySelector(href);

        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      }
    });
  });
}

// Lazy Loading
function initLazyLoading() {
  if ("IntersectionObserver" in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove("lazy");
          imageObserver.unobserve(img);
        }
      });
    });

    const lazyImages = document.querySelectorAll("img[data-src]");
    lazyImages.forEach((img) => imageObserver.observe(img));
  }
}

// Utility Functions
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function throttle(func, limit) {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

// Product Quick Actions
function addToCart(productId, variantId = null) {
  // Shopify AJAX cart API call
  const data = {
    items: [
      {
        id: variantId || productId,
        quantity: 1
      }
    ]
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  })
    .then((response) => response.json())
    .then((data) => {
      // Update cart count, show success message, etc.
      updateCartCount();
      showNotification("Product added to cart!", "success");
    })
    .catch((error) => {
      showNotification("Error adding product to cart", "error");
    });
}

function toggleWishlist(productId) {
  // Wishlist functionality
  const wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
  const index = wishlist.indexOf(productId);

  if (index > -1) {
    wishlist.splice(index, 1);
    showNotification("Removed from wishlist", "info");
  } else {
    wishlist.push(productId);
    showNotification("Added to wishlist", "success");
  }

  localStorage.setItem("wishlist", JSON.stringify(wishlist));
  updateWishlistUI(productId);
}

function updateCartCount() {
  // Update cart count in header
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartCountElements = document.querySelectorAll("[data-cart-count]");
      cartCountElements.forEach((element) => {
        element.textContent = cart.item_count;
      });
    })
    .catch((error) => {
      console.error("Error updating cart count:", error);
    });
}

// Global cart count update function
window.updateCartCount = updateCartCount;

function showNotification(message, type = "info") {
  // Create and show notification
  const notification = document.createElement("div");
  notification.className = `notification notification-${type}`;
  notification.textContent = message;

  document.body.appendChild(notification);

  setTimeout(() => {
    notification.classList.add("show");
  }, 100);

  setTimeout(() => {
    notification.classList.remove("show");
    setTimeout(() => {
      document.body.removeChild(notification);
    }, 300);
  }, 3000);
}

function updateWishlistUI(productId) {
  // Update wishlist button appearance
  const wishlistBtn = document.querySelector(
    `[data-product-id="${productId}"]`
  );
  if (wishlistBtn) {
    const wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
    if (wishlist.includes(productId)) {
      wishlistBtn.classList.add("active");
    } else {
      wishlistBtn.classList.remove("active");
    }
  }
}

// Initialize wishlist UI on page load (moved to main DOMContentLoaded listener)

// Search Modal Functionality - moved to search-modal.liquid snippet

// Brand Marquee Animation
function initBrandMarquee() {
  try {
    const scrollContainer = document.querySelector(".brand-marquee__scroll");
    if (!scrollContainer) return;

    let isPaused = false;
    let isJavaScriptAnimation = false;

    // Check if CSS animation is supported and working
    const computedStyle = window.getComputedStyle(scrollContainer);
    const animationName = computedStyle.animationName;

    if (animationName && animationName !== "none") {
      // CSS animation is working, use it
      isJavaScriptAnimation = false;
    } else {
      // Fallback to JavaScript animation
      isJavaScriptAnimation = true;
      startJavaScriptAnimation();
    }

    function startJavaScriptAnimation() {
      const containerWidth = scrollContainer.scrollWidth;
      const viewportWidth = scrollContainer.clientWidth;
      const scrollDistance = containerWidth - viewportWidth;
      let currentPosition = 0;
      const speed = 0.5; // pixels per frame

      function animate() {
        if (!isPaused) {
          currentPosition -= speed;
          if (currentPosition <= -scrollDistance) {
            currentPosition = 0;
          }
          scrollContainer.style.transform = `translateX(${currentPosition}px)`;
        }
        requestAnimationFrame(animate);
      }

      animate();
    }

    // Pause on hover
    scrollContainer.addEventListener("mouseenter", function () {
      if (isJavaScriptAnimation) {
        isPaused = true;
      } else {
        scrollContainer.style.animationPlayState = "paused";
      }
    });

    scrollContainer.addEventListener("mouseleave", function () {
      if (isJavaScriptAnimation) {
        isPaused = false;
      } else {
        scrollContainer.style.animationPlayState = "running";
      }
    });

    // Pause on touch
    scrollContainer.addEventListener("touchstart", function () {
      if (isJavaScriptAnimation) {
        isPaused = true;
      } else {
        scrollContainer.style.animationPlayState = "paused";
      }
    });

    scrollContainer.addEventListener("touchend", function () {
      if (isJavaScriptAnimation) {
        isPaused = false;
      } else {
        scrollContainer.style.animationPlayState = "running";
      }
    });
  } catch (e) {
    console.error("Error initializing brand marquee:", e);
  }
}
